import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import { Card, Upload, UploadFile, UploadProps } from 'antd';
import { IImage } from '../../interfaces/image';
import { useState } from 'react';

type Props = {
  value?: IImage;
  onChange?: (value?: IImage) => void;
  id?: string;
};

export const ImageUpload = ({ value, onChange, id }: Props) => {
  const [fileList, setFileList] = useState<UploadFile[]>(
    value
      ? [
          {
            uid: value.id,
            status: 'done',
            name: value.url,
            url: value.url,
          },
        ]
      : [],
  );
  const handleChange: UploadProps['onChange'] = (info) => {
    if (info.file.status === 'done') {
      onChange?.(info.file.response as IImage);
    }
    if (info.file.status === 'removed') {
      onChange?.(undefined);
    }
    setFileList(info.fileList.slice(-1));
  };

  return (
    <Upload
      id={id}
      name="files"
      action={`${import.meta.env.VITE_API_URL}/blobs`}
      fileList={fileList}
      onChange={handleChange}
      maxCount={1}
      listType="picture"
      showUploadList={false}
    >
      {value?.url ? (
        <img src={value.url} alt="avatar" style={{ width: '100%', cursor: 'pointer' }} />
      ) : (
        <Card style={{ cursor: 'pointer' }}>
          <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>追加</div>
          </button>
        </Card>
      )}
    </Upload>
  );
};
